import client from './client';

export const listUsers = () => client.get('/users').then((r) => r.data);
export const myStaff = () => client.get('/users/my-staff').then((r) => r.data);
export const scopeUsers = () => client.get('/users/scope').then((r) => r.data);
export const createUser = (payload) => client.post('/users', payload).then((r) => r.data);
export const updateUserFull = (id, payload) => client.put(`/users/${id}/full`, payload).then((r) => r.data);
export const removeUser = (id) => client.delete(`/users/${id}`).then((r) => r.data);
export const listDepartments = () => client.get('/users/departments').then((r) => r.data);
export const updateDepartments = (id, departments) =>
  client.put(`/users/${id}/departments`, { departments }).then((r) => r.data);
export const updateSalary = (id, payload) =>
  client.put(`/users/${id}/salary`, payload).then((r) => r.data);
export const updateSyncAgent = (id, syncAgent) =>
  client.put(`/users/${id}/sync-agent`, { syncAgent }).then((r) => r.data);
export const updateContact = (id, payload) =>
  client.put(`/users/${id}/contact`, payload).then((r) => r.data);
export const resetPassword = (id) =>
  client.put(`/users/${id}/reset-password`).then((r) => r.data);
export const salesHeads = () => client.get('/users/sales-heads').then((r) => r.data);
export const listDeptHeads = () => client.get('/users/dept-heads').then((r) => r.data);
export const setDeptHead = (department, userId) =>
  client.put('/users/dept-head', { department, userId }).then((r) => r.data);
